import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { GetIdiomasEnAPI, GetLicenciasSertecSocioEnAPI, CrearLicenciaClienteEnAPI, ModificarLicenciaClienteEnAPI, GetPaisesEnAPI, ObtenerTiposClientesEnAPI, GetMonedasEnAPI, ActualizarLicenciaNextDataSertecEnAPI, ProgramasEnAPI, HistorialUsuarioEnAPI, HistorialUsuarioLiteEnAPI } from "../../action/actionCreatorsRequests"
import { MSGOK, MSGERROR, traducirPagina, obtenerUsuario } from '../../librerias/funciones'
import { MDBBtn, MDBCol } from 'mdbreact';
import {
    SaveOutlined,
    UserAddOutlined,
    FieldTimeOutlined,
    ShoppingOutlined,
    InfoCircleOutlined,
    EuroCircleOutlined,
    DeleteOutlined,
    LoadingOutlined,
    CloseOutlined,
    ReloadOutlined

} from '@ant-design/icons';

import { Popover, Input, Row, Col, Drawer, Tabs, Checkbox, Modal, Button, Alert, Select } from 'antd';
import MantenimientoTipoCLiente from '../NextGroup/MantenimientoTipoCLiente';
import { HistorialData } from './HistorialData';
const { TabPane } = Tabs;
const { Option } = Select;


const FichaMantenimientoCliente = ({ props, configApp, usuario }) => {
    const { ID_ROL } = usuario === undefined || usuario === null ? { ID_ROL: 1 } : usuario
    const [tabPorDefecto, setTabPorDefecto] = React.useState("1");
    const [modificarBasic, setModificarBasic] = React.useState(false);

    const [fichaHistorial, setFichaHistorial] = React.useState({
        ABRIR_FICHA: false,
        ID_VERSION: 0
    });

    const [ABRIR_FICHA_TIPO_CLIENTE, setABRIR_FICHA_TIPO_CLIENTE] = React.useState(false)

    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const ref = React.useRef(null)

    const [servicios, setServicios] = React.useState([])

    const [paises, setPaises] = React.useState([])
    const [monedas, setMonedas] = React.useState([])

    const [visible, setVisible] = React.useState(false)
    const [bajaBasic, setBajaBasic] = React.useState(false)
    const [confirmarCompra, setConfirmarCompra] = React.useState({
        ABRIR_MODAL: false,
        ID_COMPRA_SELECCIONADA: null
    })




    const [hayRegistros, setHayRegistros] = React.useState(false);
    const [idiomasLocal, setIdiomasLocal] = React.useState([]);
    const [tipoCliente, setTipoCliente] = React.useState([]);
    const [historialData, setHistorialData] = React.useState([]);


    const [textoIdioma, setTextoIdioma] = React.useState(1);
    const [ID_LICENCIA, setID_LICENCIA] = React.useState(0);


    const [payLoadData, setPayLoadData] = React.useState({
        ESTADO_BASIC: 1,
        ESTADO_REPARACION: 1,
        ESTADO_COMPLETO: 1,
        ESTADO_CONTROL_LITE: 1
    })




    const [payLoadLocal, setPayLoadLocal] = React.useState(
        {
            USUARIO: "",
            PWD: "",
            DESCRIPCION: "",
            ID_SOCIO: 0,
            ID_IDIOMA: 1,
            CORREO_RECUPERACION_PWD: "",
            OBSERVACIONES: "",
            EMPRESA_SOCIO: "",
            ALMACEN: "",
            SOLO_CATALOGO: false,
            FILTRAR_MARCAS: false,
            VER_SOLO_REFERENCIAS_MARCAS_SOCIO: false,
            SIEMPRE_VERDE: false,
            SEMAFORO_DISPONIBILIDAD: false,
            PERMISO_MATRICULAS: false,
            PERMISO_NEUMATICOS: false,
            PERMISO_MOTOS: false,
            PERMISO_PRESUPUESTOS_GTESTIMATE: false,
            PERMISO_CATALOGO_ORIGINAL: false,
            MAXIMO_MATRICULAS_MENSUAL: 0,
            MAXIMO_PRESUPUESTOS_GTESTIMATE: 0,
            MAXIMO_CATALOGO_ORIGINAL: 0,
            PLANTILLA: "",
            CLIENTE: "",
            CENTRO: "",
            DEFECTO: false,
            VISUALIZAR_PVP: false,
            VISUALIZAR_ADICIONALES: false,
            PERMISO_LUBRICANTES: false,
            PERMISO_BATERIAS: false,
            ABRIR_SIEMPRE_DESGLOSE_COMPRAR: false,
            CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA: false,
            COMPRAR_SIN_DISPONIBILIDAD: false,
            FACTURACION_LITE: false,
            MOSTRAR_BOTON_POR_DEFECTO: false,
            ID_PAIS: 1,
            PERMISO_DOCUMENTACION_TECNICA: false,
            PERMISO_BASTIDORES: false,
            MAXIMO_BASTIDORES_MENSUAL: 0,
            ID_TIPO_CLIENTE: 0,
            ID_MONEDA: 0,
            ID_TIENDA_RETAIL: 0,
            NOMBRE_TIENDA_RETAIL: "",
            CODIGO_CLIENTE_TIENDA: 0,
            DAR_BAJA_BASIC: false,


            CREAR_NEXT_DATA_BASIC: false,
            BAJA_NEXT_DATA_BASIC: false,
            ORIGEN_NEXTDATA_BASIC: "HAY",
            FECHA_NEXTDATA_BASIC: "",
            CAMBIAR_ORIGEN_NEXT_DATA_BASIC: false,



            CREAR_NEXT_DATA_MANUALES: false,
            BAJA_NEXT_DATA_MANUALES: false,
            ORIGEN_NEXTDATA_MANUALES: "HAY",
            FECHA_NEXTDATA_MANUALES: "",


            CREAR_NEXT_DATA_COMPLETO: false,
            BAJA_NEXT_DATA_COMPLETO: false,
            ORIGEN_NEXTDATA_COMPLETO: "HAY",
            USUARIO_NEXTDATA_COMPLETO: "",
            PWD_NEXTDATA_COMPLETO: "",
            FECHA_NEXTDATA_COMPLETO: "",

            FECHA_CONTROL_LITE: ""

        }
    )



    const GetPaises = (ORDERCOLUM, ORDERDIR, ID, CODIGO, NOMBRE) => {
        GetPaisesEnAPI(ORDERCOLUM, ORDERDIR, ID, CODIGO, NOMBRE).then((licencia) => {
            if (licencia !== undefined && licencia !== null && licencia.REGISTROS !== null && licencia.REGISTROS.length > 0) {

                setPaises(licencia.REGISTROS)
            } else {
                setPaises(null)

            }
        })
    }


    const HistorialUsuario = async (ID) => {
        setHistorialData([])

        let licencia = await HistorialUsuarioEnAPI(ID)
        if (licencia !== undefined && licencia !== null && licencia.REGISTROS !== null && licencia.REGISTROS.length > 0) {

            setHistorialData(licencia.REGISTROS)
        } else {
            setHistorialData(null)

        }

    }



    const HistorialUsuarioLite = async (ID) => {
        setHistorialData([])

        let licencia = await HistorialUsuarioLiteEnAPI(ID)
        if (licencia !== undefined && licencia !== null && licencia.REGISTROS !== null && licencia.REGISTROS.length > 0) {

            setHistorialData(licencia.REGISTROS)
        } else {
            setHistorialData(null)

        }
    }





    const GetMonedas = (ORDERCOLUM, ORDERDIR, ID, NOMBRE) => {

        GetMonedasEnAPI(ORDERCOLUM, ORDERDIR, ID, NOMBRE).then((licencia) => {
            if (licencia !== undefined && licencia !== null && licencia.REGISTROS !== null && licencia.REGISTROS.length > 0) {
                setMonedas(licencia.REGISTROS)
            } else {
                setMonedas(null)

            }
        })
    }

    const GetCategoriaDocumento = (ID, ID_SOCIO) => {
        ObtenerTiposClientesEnAPI(ID, ID_SOCIO).then((licencia) => {
            if (licencia !== undefined && licencia !== null && licencia.REGISTROS !== null && licencia.REGISTROS.length > 0) {
                setTipoCliente(licencia.REGISTROS)
            } else {
                setTipoCliente(null)

            }
        })
    }


    const ActualizarLicenciaNextDataSertec = async (payLoadData) => {
        let ACCION = 0
        let ESTADO = null

        let licencia = await ActualizarLicenciaNextDataSertecEnAPI(ACCION, payLoadData);
        console.log("res data", licencia)

        if (licencia !== undefined && licencia !== null) {
            ESTADO = licencia
        }

        return ESTADO;
    }





    const BuscarUsuariosEnAPI = (ID, ID_SOCIO) => {
        GetLicenciasSertecSocioEnAPI(1, "A", ID_SOCIO, ID).then((cli) => {
            if (cli.LICENCIAS_SERTEC !== undefined)
                if (cli.LICENCIAS_SERTEC !== null && cli.LICENCIAS_SERTEC.length > 0) {
                    let user = cli.LICENCIAS_SERTEC[0];
                    setTextoIdioma(user.ID_IDIOMA);
                    setID_LICENCIA(user.ID_LICENCIA);

                    payLoadLocal.USUARIO = user.USUARIO
                    payLoadLocal.PWD = user.PWD
                    payLoadLocal.DESCRIPCION = user.NOMBRE_USUARIO
                    payLoadLocal.ID_SOCIO = user.ID_SOCIO
                    payLoadLocal.ID_IDIOMA = user.ID_IDIOMA
                    payLoadLocal.CORREO_RECUPERACION_PWD = user.CORREO_RECUPERACION_PWD
                    payLoadLocal.OBSERVACIONES = user.OBSERVACIONES
                    payLoadLocal.EMPRESA_SOCIO = user.EMPRESA_SOCIO
                    payLoadLocal.ALMACEN = user.ALMACEN
                    payLoadLocal.SOLO_CATALOGO = user.SOLO_CATALOGO
                    payLoadLocal.FILTRAR_MARCAS = user.FILTRAR_MARCAS_SOCIO
                    payLoadLocal.VER_SOLO_REFERENCIAS_MARCAS_SOCIO = user.VER_SOLO_REFERENCIAS_MARCAS_SOCIO
                    payLoadLocal.SIEMPRE_VERDE = user.SIEMPRE_VERDE
                    payLoadLocal.SEMAFORO_DISPONIBILIDAD = user.SEMAFORO_DISPONIBILIDAD
                    payLoadLocal.PERMISO_MATRICULAS = user.PERMISO_MATRICULAS
                    payLoadLocal.PERMISO_NEUMATICOS = user.PERMISO_NEUMATICOS
                    payLoadLocal.PERMISO_MOTOS = user.PERMISO_MOTOS
                    payLoadLocal.PERMISO_PRESUPUESTOS_GTESTIMATE = user.PERMISO_PRESUPUESTOS_GTESTIMATE
                    payLoadLocal.PERMISO_CATALOGO_ORIGINAL = user.PERMISO_CATALOGO_ORIGINAL
                    payLoadLocal.MAXIMO_MATRICULAS_MENSUAL = user.MAXIMO_MATRICULAS_MENSUAL
                    payLoadLocal.MAXIMO_PRESUPUESTOS_GTESTIMATE = user.MAXIMO_PRESUPUESTOS_GTESTIMATE
                    payLoadLocal.MAXIMO_CATALOGO_ORIGINAL = user.MAXIMO_CATALOGO_ORIGINAL
                    payLoadLocal.PLANTILLA = user.PLANTILLA
                    payLoadLocal.CLIENTE = user.CLIENTE
                    payLoadLocal.CENTRO = user.CENTRO
                    payLoadLocal.DEFECTO = user.DEFECTO
                    payLoadLocal.VISUALIZAR_PVP = user.VISUALIZAR_PVP
                    payLoadLocal.VISUALIZAR_ADICIONALES = user.VISUALIZAR_ADICIONALES
                    payLoadLocal.PERMISO_LUBRICANTES = user.PERMISO_LUBRICANTES
                    payLoadLocal.PERMISO_BATERIAS = user.PERMISO_BATERIAS
                    payLoadLocal.ABRIR_SIEMPRE_DESGLOSE_COMPRAR = user.ABRIR_SIEMPRE_DESGLOSE_COMPRAR
                    payLoadLocal.CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA = user.CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA
                    payLoadLocal.COMPRAR_SIN_DISPONIBILIDAD = user.COMPRAR_SIN_DISPONIBILIDAD
                    payLoadLocal.FACTURACION_LITE = user.FACTURACION_LITE
                    payLoadLocal.MOSTRAR_BOTON_POR_DEFECTO = user.MOSTRAR_BOTON_POR_DEFECTO
                    payLoadLocal.ID_PAIS = user.ID_PAIS
                    payLoadLocal.PERMISO_DOCUMENTACION_TECNICA = user.PERMISO_DOCUMENTACION_TECNICA
                    payLoadLocal.PERMISO_BASTIDORES = user.PERMISO_BASTIDORES
                    payLoadLocal.MAXIMO_BASTIDORES_MENSUAL = user.MAXIMO_BASTIDORES_MENSUAL
                    payLoadLocal.ID_TIPO_CLIENTE = user.ID_TIPO_CLIENTE
                    payLoadLocal.ID_MONEDA = user.ID_MONEDA

                    payLoadLocal.ID_TIENDA_RETAIL = user.ID_TIENDA_RETAIL
                    payLoadLocal.NOMBRE_TIENDA_RETAIL = user.NOMBRE_TIENDA_RETAIL
                    payLoadLocal.CODIGO_CLIENTE_TIENDA = user.CODIGO_CLIENTE_TIENDA

                    let BASIC = user.NEXTDATA.find((item) => item.ID_VERSION === 5)
                    let MANUALES = user.NEXTDATA.find((item) => item.ID_VERSION === 4)
                    let COMPLETO = user.NEXTDATA.find((item) => item.ID_VERSION === 1)
                    let NEX_CONTROL = user.NEXTCONTROL.find((item) => item.SERVICIO === "NEXTCONTROLLITE")


                    if (BASIC !== undefined) {
                        payLoadLocal.FECHA_NEXTDATA_BASIC = BASIC.FECHA_ALTA
                        payLoadLocal.ORIGEN_NEXTDATA_BASIC = BASIC.PROGRAMA
                        payLoadData.ESTADO_BASIC = BASIC.BAJA ? 1 : 2
                    }

                    if (MANUALES !== undefined) {
                        payLoadLocal.FECHA_NEXTDATA_MANUALES = MANUALES.FECHA_ALTA
                        payLoadLocal.ORIGEN_NEXTDATA_MANUALES = MANUALES.PROGRAMA
                        payLoadData.ESTADO_REPARACION = MANUALES.BAJA ? 1 : 2

                    }

                    if (COMPLETO !== undefined) {
                        payLoadLocal.FECHA_NEXTDATA_COMPLETO = COMPLETO.FECHA_ALTA
                        payLoadLocal.ORIGEN_NEXTDATA_COMPLETO = COMPLETO.PROGRAMA
                        payLoadData.ESTADO_COMPLETO = COMPLETO.BAJA ? 1 : 2
                        payLoadLocal.USUARIO_NEXTDATA_COMPLETO = COMPLETO.USUARIO
                        payLoadLocal.PWD_NEXTDATA_COMPLETO = COMPLETO.PWD

                    }

                    if (NEX_CONTROL !== undefined) {
                        payLoadLocal.FECHA_CONTROL_LITE = NEX_CONTROL.FECHA_ALTA

                        payLoadData.ESTADO_CONTROL_LITE = NEX_CONTROL.BAJA ? 1 : 2
                    }

                    setPayLoadLocal({ ...payLoadLocal })
                    setPayLoadData({ ...payLoadData })
                }
        })
    }



    if (!hayRegistros && props.ESTADO_FICHA) {
        setHayRegistros(true);
        //CLIENTE SELECCIONADO
        if (Object.keys(props.DATOS_CLIENTE).length > 0) {
            const { Codigo, ID_TIENDA_RETAIL, NOMBRE_TIENDA_RETAIL, CODIGO_CLIENTE_SOCIO, CODIGO_CLIENTE_TIENDA } = props.DATOS_CLIENTE

            payLoadLocal.CLIENTE = Codigo


            //  console.log("ID_TIENDA_RETAIL", ID_TIENDA_RETAIL, "NOMBRE_TIENDA_RETAIL", NOMBRE_TIENDA_RETAIL, "CODIGO_CLIENTE_SOCIO", CODIGO_CLIENTE_SOCIO)

            payLoadLocal.ID_TIENDA_RETAIL = ID_TIENDA_RETAIL
            payLoadLocal.NOMBRE_TIENDA_RETAIL = NOMBRE_TIENDA_RETAIL

            if (CODIGO_CLIENTE_SOCIO !== undefined) {
                payLoadLocal.CODIGO_CLIENTE_TIENDA = Codigo
            } else {
                if (CODIGO_CLIENTE_TIENDA !== undefined && CODIGO_CLIENTE_TIENDA !== undefined !== "") {
                    payLoadLocal.CODIGO_CLIENTE_TIENDA = CODIGO_CLIENTE_TIENDA
                } else {
                    payLoadLocal.CODIGO_CLIENTE_TIENDA = undefined
                }
            }


            setPayLoadLocal({ ...payLoadLocal })
        } else {
            BuscarUsuariosEnAPI(props.ID_USUARIO, props.ID_SOCIO)
        }


        GetIdiomasEnAPI().then(idiomas => {
            if (idiomas !== undefined) {
                if (idiomas !== null && idiomas.length > 0) {
                    setIdiomasLocal(idiomas)

                } else {
                    setIdiomasLocal(null)
                }
            }
        })

        GetPaises(1, "A", "", "", "");

        GetCategoriaDocumento(null, props.ID_SOCIO)
        GetMonedas(1, "A", "", "");

        if (props.ID_USUARIO !== 0) {
            HistorialUsuario(props.ID_USUARIO)
        }

        ProgramasEnAPI().then((PROGRAMAS) => {
            if (PROGRAMAS !== undefined && PROGRAMAS !== null && PROGRAMAS.REGISTROS !== null && PROGRAMAS.REGISTROS.length > 0) {

                /*
                let PRIMER_ITEM = PROGRAMAS.REGISTROS[0];
                payLoadLocal.ORIGEN_NEXTDATA_BASIC = PRIMER_ITEM.CODIGO
                payLoadLocal.ORIGEN_NEXTDATA_MANUALES = PRIMER_ITEM.CODIGO
                payLoadLocal.ORIGEN_NEXTDATA_COMPLETO = PRIMER_ITEM.CODIGO
                setPayLoadLocal({ ...payLoadLocal })
*/

                setServicios(PROGRAMAS.REGISTROS)
            }
        });


        const { SOCIOS } = obtenerUsuario();
        if (SOCIOS !== undefined && SOCIOS !== null) {
            let PERMITIR_MODIFICAR = SOCIOS.find((item) => item.ID_SOCIO === props.ID_SOCIO)
            console.log("PERMITIR_MODIFICAR", PERMITIR_MODIFICAR)
            setModificarBasic(PERMITIR_MODIFICAR.PERMISO_MODIFICAR_NEXT_DATA_BASIC)
        }



    } else {
        if (!props.ESTADO_FICHA && hayRegistros) {
            setHayRegistros(false);
            setIdiomasLocal([])
            setTabPorDefecto("1")
            setTextoIdioma(1)
            payLoadData.ESTADO_BASIC = 1
            payLoadData.ESTADO_REPARACION = 1
            payLoadData.ESTADO_COMPLETO = 1
            payLoadData.ESTADO_CONTROL_LITE = 1

            setPayLoadData({ ...payLoadData })


            setPayLoadLocal({
                USUARIO: "",
                PWD: "",
                DESCRIPCION: "",
                ID_SOCIO: 0,
                ID_IDIOMA: 1,
                CORREO_RECUPERACION_PWD: "",
                OBSERVACIONES: "",
                EMPRESA_SOCIO: "",
                ALMACEN: "",
                SOLO_CATALOGO: false,
                FILTRAR_MARCAS: false,
                VER_SOLO_REFERENCIAS_MARCAS_SOCIO: false,
                SIEMPRE_VERDE: false,
                SEMAFORO_DISPONIBILIDAD: false,
                PERMISO_MATRICULAS: false,
                PERMISO_NEUMATICOS: false,
                PERMISO_MOTOS: false,
                PERMISO_PRESUPUESTOS_GTESTIMATE: false,
                PERMISO_CATALOGO_ORIGINAL: false,
                MAXIMO_MATRICULAS_MENSUAL: 0,
                MAXIMO_PRESUPUESTOS_GTESTIMATE: 0,
                MAXIMO_CATALOGO_ORIGINAL: 0,
                PLANTILLA: "",
                VISUALIZAR_PVP: "",
                VISUALIZAR_ADICIONALES: "",
                PERMISO_LUBRICANTES: false,
                PERMISO_BATERIAS: false,
                ABRIR_SIEMPRE_DESGLOSE_COMPRAR: false,

                CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA: false,
                COMPRAR_SIN_DISPONIBILIDAD: false,
                FACTURACION_LITE: false,
                MOSTRAR_BOTON_POR_DEFECTO: false,
                ID_PAIS: 1,
                PERMISO_DOCUMENTACION_TECNICA: false,
                PERMISO_BASTIDORES: false,
                MAXIMO_BASTIDORES_MENSUAL: 0,
                ID_TIPO_CLIENTE: 0,
                ID_MONEDA: 0,
                ID_TIENDA_RETAIL: 0,
                NOMBRE_TIENDA_RETAIL: "",
                CODIGO_CLIENTE_TIENDA: 0,
                DAR_BAJA_BASIC: false,

                CREAR_NEXT_DATA_BASIC: false,
                BAJA_NEXT_DATA_BASIC: false,
                ORIGEN_NEXTDATA_BASIC: "HAY",
                FECHA_NEXTDATA_BASIC: "",
                CAMBIAR_ORIGEN_NEXT_DATA_BASIC: false,


                CREAR_NEXT_DATA_MANUALES: false,
                BAJA_NEXT_DATA_MANUALES: false,
                ORIGEN_NEXTDATA_MANUALES: "HAY",
                FECHA_NEXTDATA_MANUALES: "",



                CREAR_NEXT_DATA_COMPLETO: false,
                BAJA_NEXT_DATA_COMPLETO: false,
                ORIGEN_NEXTDATA_COMPLETO: "HAY",
                USUARIO_NEXTDATA_COMPLETO: "",
                PWD_NEXTDATA_COMPLETO: "",
                FECHA_NEXTDATA_COMPLETO: "",

                FECHA_CONTROL_LITE: ""

            })
        }
    }

    const guardarEstadoFormulario = (e) => {
        const USUARIO = e.target.name === 'USUARIO' ? e.target.value : payLoadLocal.USUARIO;
        const PWD = e.target.name === 'PWD' ? e.target.value : payLoadLocal.PWD;
        const DESCRIPCION = e.target.name === 'DESCRIPCION' ? e.target.value : payLoadLocal.DESCRIPCION;
        const ID_SOCIO = e.target.name === 'ID_SOCIO' ? e.target.value : payLoadLocal.ID_SOCIO;
        const ID_IDIOMA = e.target.name === 'ID_IDIOMA' ? parseInt(e.target.value) : payLoadLocal.ID_IDIOMA;
        const CORREO_RECUPERACION_PWD = e.target.name === 'CORREO_RECUPERACION_PWD' ? e.target.value : payLoadLocal.CORREO_RECUPERACION_PWD;
        const OBSERVACIONES = e.target.name === 'OBSERVACIONES' ? e.target.value : payLoadLocal.OBSERVACIONES;
        const EMPRESA_SOCIO = e.target.name === 'EMPRESA_SOCIO' ? e.target.value : payLoadLocal.EMPRESA_SOCIO;
        const ALMACEN = e.target.name === 'ALMACEN' ? e.target.value : payLoadLocal.ALMACEN;
        const SOLO_CATALOGO = e.target.name === 'SOLO_CATALOGO' ? e.target.checked : payLoadLocal.SOLO_CATALOGO;
        const FILTRAR_MARCAS = e.target.name === 'FILTRAR_MARCAS' ? e.target.checked : payLoadLocal.FILTRAR_MARCAS;
        const VER_SOLO_REFERENCIAS_MARCAS_SOCIO = e.target.name === 'VER_SOLO_REFERENCIAS_MARCAS_SOCIO' ? e.target.checked : payLoadLocal.VER_SOLO_REFERENCIAS_MARCAS_SOCIO;
        const SIEMPRE_VERDE = e.target.name === 'SIEMPRE_VERDE' ? e.target.checked : payLoadLocal.SIEMPRE_VERDE;
        const SEMAFORO_DISPONIBILIDAD = e.target.name === 'SEMAFORO_DISPONIBILIDAD' ? e.target.checked : payLoadLocal.SEMAFORO_DISPONIBILIDAD;
        const PERMISO_MATRICULAS = e.target.name === 'PERMISO_MATRICULAS' ? e.target.checked : payLoadLocal.PERMISO_MATRICULAS;
        const PERMISO_NEUMATICOS = e.target.name === 'PERMISO_NEUMATICOS' ? e.target.checked : payLoadLocal.PERMISO_NEUMATICOS;
        const PERMISO_MOTOS = e.target.name === 'PERMISO_MOTOS' ? e.target.checked : payLoadLocal.PERMISO_MOTOS;


        const PERMISO_PRESUPUESTOS_GTESTIMATE = e.target.name === 'PERMISO_PRESUPUESTOS_GTESTIMATE' ? e.target.checked : payLoadLocal.PERMISO_PRESUPUESTOS_GTESTIMATE;
        const PERMISO_CATALOGO_ORIGINAL = e.target.name === 'PERMISO_CATALOGO_ORIGINAL' ? e.target.checked : payLoadLocal.PERMISO_CATALOGO_ORIGINAL;


        const MAXIMO_MATRICULAS_MENSUAL = e.target.name === 'MAXIMO_MATRICULAS_MENSUAL' ? e.target.value : payLoadLocal.MAXIMO_MATRICULAS_MENSUAL;
        const MAXIMO_PRESUPUESTOS_GTESTIMATE = e.target.name === 'MAXIMO_PRESUPUESTOS_GTESTIMATE' ? e.target.value : payLoadLocal.MAXIMO_PRESUPUESTOS_GTESTIMATE;
        const MAXIMO_CATALOGO_ORIGINAL = e.target.name === 'MAXIMO_CATALOGO_ORIGINAL' ? e.target.value : payLoadLocal.MAXIMO_CATALOGO_ORIGINAL;


        const PLANTILLA = e.target.name === 'PLANTILLA' ? e.target.value : payLoadLocal.PLANTILLA;
        const CLIENTE = e.target.name === 'CLIENTE' ? e.target.value : payLoadLocal.CLIENTE;
        const CENTRO = e.target.name === 'CENTRO' ? e.target.value : payLoadLocal.CENTRO;
        const DEFECTO = e.target.name === 'DEFECTO' ? e.target.checked : payLoadLocal.DEFECTO;
        const VISUALIZAR_PVP = e.target.name === 'VISUALIZAR_PVP' ? e.target.checked : payLoadLocal.VISUALIZAR_PVP;
        const VISUALIZAR_ADICIONALES = e.target.name === 'VISUALIZAR_ADICIONALES' ? e.target.checked : payLoadLocal.VISUALIZAR_ADICIONALES;

        const PERMISO_LUBRICANTES = e.target.name === 'PERMISO_LUBRICANTES' ? e.target.checked : payLoadLocal.PERMISO_LUBRICANTES;
        const PERMISO_BATERIAS = e.target.name === 'PERMISO_BATERIAS' ? e.target.checked : payLoadLocal.PERMISO_BATERIAS;
        const ABRIR_SIEMPRE_DESGLOSE_COMPRAR = e.target.name === 'ABRIR_SIEMPRE_DESGLOSE_COMPRAR' ? e.target.checked : payLoadLocal.ABRIR_SIEMPRE_DESGLOSE_COMPRAR;
        const CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA = e.target.name === 'CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA' ? e.target.checked : payLoadLocal.CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA;
        const COMPRAR_SIN_DISPONIBILIDAD = e.target.name === 'COMPRAR_SIN_DISPONIBILIDAD' ? e.target.checked : payLoadLocal.COMPRAR_SIN_DISPONIBILIDAD;


        const FACTURACION_LITE = e.target.name === 'FACTURACION_LITE' ? e.target.checked : payLoadLocal.FACTURACION_LITE;
        const MOSTRAR_BOTON_POR_DEFECTO = e.target.name === 'MOSTRAR_BOTON_POR_DEFECTO' ? e.target.checked : payLoadLocal.MOSTRAR_BOTON_POR_DEFECTO;
        const ID_PAIS = e.target.name === 'ID_PAIS' ? e.target.value : payLoadLocal.ID_PAIS;
        const PERMISO_DOCUMENTACION_TECNICA = e.target.name === 'PERMISO_DOCUMENTACION_TECNICA' ? e.target.checked : payLoadLocal.PERMISO_DOCUMENTACION_TECNICA;
        const PERMISO_BASTIDORES = e.target.name === 'PERMISO_BASTIDORES' ? e.target.checked : payLoadLocal.PERMISO_BASTIDORES;
        const MAXIMO_BASTIDORES_MENSUAL = e.target.name === 'MAXIMO_BASTIDORES_MENSUAL' ? e.target.value : payLoadLocal.MAXIMO_BASTIDORES_MENSUAL;

        const ID_TIPO_CLIENTE = e.target.name === 'ID_TIPO_CLIENTE' ? parseInt(e.target.value) : payLoadLocal.ID_TIPO_CLIENTE;
        const ID_MONEDA = e.target.name === 'ID_MONEDA' ? parseInt(e.target.value) : payLoadLocal.ID_MONEDA;

        const ID_TIENDA_RETAIL = e.target.name === 'ID_TIENDA_RETAIL' ? parseInt(e.target.value) : payLoadLocal.ID_TIENDA_RETAIL;
        const NOMBRE_TIENDA_RETAIL = e.target.name === 'NOMBRE_TIENDA_RETAIL' ? e.target.value : payLoadLocal.NOMBRE_TIENDA_RETAIL;
        const CODIGO_CLIENTE_TIENDA = e.target.name === 'CODIGO_CLIENTE_TIENDA' ? e.target.value : payLoadLocal.CODIGO_CLIENTE_TIENDA;
        const DAR_BAJA_BASIC = e.target.name === 'DAR_BAJA_BASIC' ? e.target.checked : payLoadLocal.DAR_BAJA_BASIC;



        const CREAR_NEXT_DATA_BASIC = e.target.name === 'CREAR_NEXT_DATA_BASIC' ? e.target.value : payLoadLocal.CREAR_NEXT_DATA_BASIC;
        const BAJA_NEXT_DATA_BASIC = e.target.name === 'BAJA_NEXT_DATA_BASIC' ? e.target.value : payLoadLocal.BAJA_NEXT_DATA_BASIC;
        const ORIGEN_NEXTDATA_BASIC = e.target.name === 'ORIGEN_NEXTDATA_BASIC' ? e.target.value : payLoadLocal.ORIGEN_NEXTDATA_BASIC;
        const FECHA_NEXTDATA_BASIC = e.target.name === 'FECHA_NEXTDATA_BASIC' ? e.target.value : payLoadLocal.FECHA_NEXTDATA_BASIC;
        const CAMBIAR_ORIGEN_NEXT_DATA_BASIC = e.target.name === 'CAMBIAR_ORIGEN_NEXT_DATA_BASIC' ? e.target.value : payLoadLocal.CAMBIAR_ORIGEN_NEXT_DATA_BASIC;



        const CREAR_NEXT_DATA_MANUALES = e.target.name === 'CREAR_NEXT_DATA_MANUALES' ? e.target.value : payLoadLocal.CREAR_NEXT_DATA_MANUALES;
        const BAJA_NEXT_DATA_MANUALES = e.target.name === 'BAJA_NEXT_DATA_MANUALES' ? e.target.value : payLoadLocal.BAJA_NEXT_DATA_MANUALES;
        const ORIGEN_NEXTDATA_MANUALES = e.target.name === 'ORIGEN_NEXTDATA_MANUALES' ? e.target.value : payLoadLocal.ORIGEN_NEXTDATA_MANUALES;
        const FECHA_NEXTDATA_MANUALES = e.target.name === 'FECHA_NEXTDATA_MANUALES' ? e.target.value : payLoadLocal.FECHA_NEXTDATA_MANUALES;



        const CREAR_NEXT_DATA_COMPLETO = e.target.name === 'CREAR_NEXT_DATA_COMPLETO' ? e.target.value : payLoadLocal.CREAR_NEXT_DATA_COMPLETO;
        const BAJA_NEXT_DATA_COMPLETO = e.target.name === 'BAJA_NEXT_DATA_COMPLETO' ? e.target.value : payLoadLocal.BAJA_NEXT_DATA_COMPLETO;
        const ORIGEN_NEXTDATA_COMPLETO = e.target.name === 'ORIGEN_NEXTDATA_COMPLETO' ? e.target.value : payLoadLocal.ORIGEN_NEXTDATA_COMPLETO;
        const USUARIO_NEXTDATA_COMPLETO = e.target.name === 'USUARIO_NEXTDATA_COMPLETO' ? e.target.value : payLoadLocal.USUARIO_NEXTDATA_COMPLETO;
        const PWD_NEXTDATA_COMPLETO = e.target.name === 'PWD_NEXTDATA_COMPLETO' ? e.target.value : payLoadLocal.PWD_NEXTDATA_COMPLETO;
        const FECHA_NEXTDATA_COMPLETO = e.target.name === 'FECHA_NEXTDATA_COMPLETO' ? e.target.value : payLoadLocal.FECHA_NEXTDATA_COMPLETO;

        const FECHA_CONTROL_LITE = e.target.name === 'FECHA_CONTROL_LITE' ? e.target.value : payLoadLocal.FECHA_CONTROL_LITE;



        setPayLoadLocal(
            {
                USUARIO: USUARIO,
                PWD: PWD,
                DESCRIPCION: DESCRIPCION,
                ID_SOCIO: ID_SOCIO,
                ID_IDIOMA: ID_IDIOMA,
                CORREO_RECUPERACION_PWD: CORREO_RECUPERACION_PWD,
                OBSERVACIONES: OBSERVACIONES,
                EMPRESA_SOCIO: EMPRESA_SOCIO,
                ALMACEN: ALMACEN,
                SOLO_CATALOGO: SOLO_CATALOGO,
                FILTRAR_MARCAS: FILTRAR_MARCAS,
                VER_SOLO_REFERENCIAS_MARCAS_SOCIO: VER_SOLO_REFERENCIAS_MARCAS_SOCIO,
                SIEMPRE_VERDE: SEMAFORO_DISPONIBILIDAD ? false : SIEMPRE_VERDE,
                SEMAFORO_DISPONIBILIDAD: SIEMPRE_VERDE ? false : SEMAFORO_DISPONIBILIDAD,
                PERMISO_MATRICULAS: PERMISO_MATRICULAS,
                PERMISO_NEUMATICOS: PERMISO_NEUMATICOS,
                PERMISO_MOTOS: PERMISO_MOTOS,
                PERMISO_PRESUPUESTOS_GTESTIMATE: PERMISO_PRESUPUESTOS_GTESTIMATE,
                PERMISO_CATALOGO_ORIGINAL: PERMISO_CATALOGO_ORIGINAL,
                MAXIMO_MATRICULAS_MENSUAL: MAXIMO_MATRICULAS_MENSUAL,
                MAXIMO_PRESUPUESTOS_GTESTIMATE: MAXIMO_PRESUPUESTOS_GTESTIMATE,
                MAXIMO_CATALOGO_ORIGINAL: MAXIMO_CATALOGO_ORIGINAL,
                PLANTILLA: PLANTILLA,
                CLIENTE: CLIENTE,
                CENTRO: CENTRO,
                DEFECTO: DEFECTO,
                VISUALIZAR_PVP: VISUALIZAR_PVP,
                VISUALIZAR_ADICIONALES: VISUALIZAR_ADICIONALES,
                PERMISO_LUBRICANTES: PERMISO_LUBRICANTES,
                PERMISO_BATERIAS: PERMISO_BATERIAS,
                ABRIR_SIEMPRE_DESGLOSE_COMPRAR: ABRIR_SIEMPRE_DESGLOSE_COMPRAR,
                CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA: CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA,
                COMPRAR_SIN_DISPONIBILIDAD: COMPRAR_SIN_DISPONIBILIDAD,

                FACTURACION_LITE: FACTURACION_LITE,
                MOSTRAR_BOTON_POR_DEFECTO: MOSTRAR_BOTON_POR_DEFECTO,
                ID_PAIS: ID_PAIS,
                PERMISO_DOCUMENTACION_TECNICA: PERMISO_DOCUMENTACION_TECNICA,
                PERMISO_BASTIDORES: PERMISO_BASTIDORES,
                MAXIMO_BASTIDORES_MENSUAL: MAXIMO_BASTIDORES_MENSUAL,
                ID_TIPO_CLIENTE: ID_TIPO_CLIENTE,
                ID_MONEDA: ID_MONEDA,

                ID_TIENDA_RETAIL: ID_TIENDA_RETAIL,
                NOMBRE_TIENDA_RETAIL: NOMBRE_TIENDA_RETAIL,

                CODIGO_CLIENTE_TIENDA: CODIGO_CLIENTE_TIENDA,

                DAR_BAJA_BASIC: DAR_BAJA_BASIC,



                CREAR_NEXT_DATA_BASIC: CREAR_NEXT_DATA_BASIC,
                BAJA_NEXT_DATA_BASIC: BAJA_NEXT_DATA_BASIC,
                ORIGEN_NEXTDATA_BASIC: ORIGEN_NEXTDATA_BASIC,
                FECHA_NEXTDATA_BASIC: FECHA_NEXTDATA_BASIC,
                CAMBIAR_ORIGEN_NEXT_DATA_BASIC: CAMBIAR_ORIGEN_NEXT_DATA_BASIC,


                CREAR_NEXT_DATA_MANUALES: CREAR_NEXT_DATA_MANUALES,
                BAJA_NEXT_DATA_MANUALES: BAJA_NEXT_DATA_MANUALES,
                ORIGEN_NEXTDATA_MANUALES: ORIGEN_NEXTDATA_MANUALES,
                FECHA_NEXTDATA_MANUALES: FECHA_NEXTDATA_MANUALES,


                CREAR_NEXT_DATA_COMPLETO: CREAR_NEXT_DATA_COMPLETO,
                BAJA_NEXT_DATA_COMPLETO: BAJA_NEXT_DATA_COMPLETO,
                ORIGEN_NEXTDATA_COMPLETO: ORIGEN_NEXTDATA_COMPLETO,
                USUARIO_NEXTDATA_COMPLETO: USUARIO_NEXTDATA_COMPLETO,
                PWD_NEXTDATA_COMPLETO: PWD_NEXTDATA_COMPLETO,
                FECHA_NEXTDATA_COMPLETO: FECHA_NEXTDATA_COMPLETO,


                FECHA_CONTROL_LITE: FECHA_CONTROL_LITE

            }
        )
    }

    const modificarIdioma = (e) => {
        payLoadLocal.ID_IDIOMA = e;

        setPayLoadLocal(payLoadLocal)
        setTextoIdioma(e)
    }

    const actualizarEstado = () => {
        GetCategoriaDocumento(null, props.ID_SOCIO)

    }

    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }
    })


    const crearUsuario = () => {


        console.log("PREVIA", payLoadLocal)

        payLoadLocal.ID_SOCIO = props.ID_SOCIO
        if (payLoadLocal.MAXIMO_MATRICULAS_MENSUAL.toString().trim() === "") {
            MSGERROR("Debe ingresar un número en Matriculas max")
        } else if (payLoadLocal.MAXIMO_BASTIDORES_MENSUAL.toString().trim() === "") {
            MSGERROR("Debe ingresar un número en Bastidores max")
        } else {

            if (Object.keys(props.DATOS_CLIENTE).length > 0) {
                const { CODIGO_CLIENTE_SOCIO } = props.DATOS_CLIENTE

                if (CODIGO_CLIENTE_SOCIO !== undefined) {
                    props.DATOS_CLIENTE.Codigo = CODIGO_CLIENTE_SOCIO
                }

                payLoadLocal.CREAR_NEXT_DATA_BASIC = true

                CrearLicenciaClienteEnAPI(payLoadLocal, props.DATOS_CLIENTE).then(usuario => {
                    if (usuario !== undefined) {
                        if (usuario.OK) {
                            MSGOK("Usuario creado correctamente.")

                            props.ACTUALIZAR_LICENCIAS(1, "A", props.ID_SOCIO)
                            props.TEXTO_BUSCADOR("")
                            props.CERRAR_FICHA(false);
                            //SE LIMPIA EL CLIENTE SELECCIONADO
                            props.DATOS_CLIENTE_SELECCIONADO({})

                        }
                    }
                })


            } else {

                ModificarLicenciaClienteEnAPI(payLoadLocal, props.ID_USUARIO, ID_LICENCIA).then(usuario => {
                    if (usuario !== undefined) {
                        if (usuario.OK) {
                            MSGOK("Usuario modificado correctamente.")
                            props.ACTUALIZAR_LICENCIAS(1, "A", props.ID_SOCIO)
                            props.TEXTO_BUSCADOR("")
                            props.CERRAR_FICHA(false);
                        }
                    }
                })
            }
        }

    }

    {/**   width={550} */ }
    return (
        <>
            <Drawer
                width={"50%"}
                onClose={() => {
                    props.CERRAR_FICHA(false);
                    props.DATOS_CLIENTE_SELECCIONADO({})
                }}
                closable={false}
                visible={props.ESTADO_FICHA}
                placement={"right"}
                bodyStyle={{ padding: '0px' }}
                style={{ color: '#fff' }}>


                <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => { props.CERRAR_FICHA(false); props.DATOS_CLIENTE_SELECCIONADO({}) }}></CloseOutlined >
                        <div> {props.title}</div>
                    </div>

                    <div className='itemHeaderDrawer2'>

                    </div>
                </div>




                <Tabs defaultActiveKey={"1"} activeKey={tabPorDefecto} onChange={(tab) => setTabPorDefecto(tab)} >
                    <TabPane tab={traducirPagina("txt_general")} key="1" className="altura_container_licencias">
                        <Alert message={traducirPagina("info_doc_general")} type="info" className="personalizar_alert" ref={ref} />
                        <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000', overflow: 'auto' }}>
                            <Col md={12}>
                                <span>{traducirPagina("Usuario")} </span>
                            </Col>
                            <Col md={12}>
                                <span>{traducirPagina("Contrasenia")} </span>
                            </Col>

                            <Col md={12}>
                                <Input name="USUARIO" autocomplete="off" value={payLoadLocal.USUARIO} onChange={(e) => guardarEstadoFormulario(e)} />
                                <br></br>
                                <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_usuario")}</span>
                            </Col>

                            <Col md={12}>
                                <Input name="PWD" type="text" autocomplete="off" value={payLoadLocal.PWD} onChange={(e) => guardarEstadoFormulario(e)} />
                                <br></br>
                                <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_contrasenna")}</span>
                            </Col>


                            <Col md={24}>
                                <span>{traducirPagina("Info_cliente_correo")}</span>
                            </Col>

                            <Col md={24}>
                                <Input name="CORREO_RECUPERACION_PWD" value={payLoadLocal.CORREO_RECUPERACION_PWD} onChange={(e) => guardarEstadoFormulario(e)} />

                                <br></br>

                                <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_correorecuperacion")}</span>
                            </Col>

                            <Col md={24}>
                                <span>{traducirPagina("Descripcion")} </span>
                            </Col>
                            <Col md={24} style={{ marginBottom: '20px' }}>
                                <Input name="DESCRIPCION" value={payLoadLocal.DESCRIPCION} onChange={(e) => guardarEstadoFormulario(e)} />
                                <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("Info_cliente_usuario")}</span>
                            </Col>



                            <Col md={8}>
                                <span>{traducirPagina("Pais")} </span>
                            </Col>
                            <Col md={8}>
                                <span>{traducirPagina("Idioma")} </span>
                            </Col>

                            <Col md={8}>
                                <span>{traducirPagina("Moneda")} </span>
                            </Col>

                            <Col md={8}>
                                {paises !== null ?
                                    <select value={payLoadLocal.ID_PAIS} className="custom-select"
                                        onChange={(e) => {
                                            payLoadLocal.ID_PAIS = parseInt(e.target.value)
                                            setPayLoadLocal({ ...payLoadLocal })
                                        }}>
                                        {paises.length > 0 ?
                                            paises.map((pais) =>
                                                <option key={pais.ID} value={pais.ID}>{pais.NOMBRE}</option>
                                            )
                                            :
                                            null
                                        }
                                    </select>
                                    :
                                    <div style={{ textAlign: 'center', }}>
                                        <h4>{traducirPagina("Sin_registros")}</h4>
                                    </div>
                                }


                                <br></br>

                                <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_pais")}</span>
                            </Col>



                            <Col md={8}>
                                {idiomasLocal !== null ?
                                    <select value={textoIdioma} className="custom-select" name={"ID_IDIOMA"}
                                        onChange={(e) => { modificarIdioma(e.target.value); guardarEstadoFormulario(e) }}>
                                        {idiomasLocal.length > 0 ?
                                            idiomasLocal.map((idioma) =>
                                                <option key={idioma.ID} value={idioma.ID}>{idioma.NOMBRE}</option>
                                            )
                                            :
                                            null
                                        }
                                    </select>
                                    :
                                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                        <h4>{traducirPagina("Info_error_idioma")}</h4>
                                    </div>
                                }

                                <br></br>

                                <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_idioma")}</span>
                            </Col>




                            <Col md={8}>
                                {monedas !== null ?
                                    <select value={payLoadLocal.ID_MONEDA} className="custom-select"
                                        onChange={(e) => {
                                            payLoadLocal.ID_MONEDA = parseInt(e.target.value)
                                            setPayLoadLocal({ ...payLoadLocal })
                                        }}>
                                        {monedas.length > 0 ?
                                            monedas.map((moneda) =>
                                                <option key={moneda.ID} value={moneda.ID}>{moneda.NOMBRE}</option>
                                            )
                                            :
                                            null
                                        }
                                    </select>
                                    :
                                    <div style={{ textAlign: 'center', }}>
                                        <h4>{traducirPagina("Sin_registros")}</h4>
                                    </div>
                                }


                                <br></br>

                                <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_moneda")}</span>
                            </Col>


                            <Col md={24}>
                                <span>{traducirPagina("Observaciones")}</span>
                            </Col>

                            <Col md={24} style={{ marginBottom: '20px' }}>
                                <Input name="OBSERVACIONES" value={payLoadLocal.OBSERVACIONES} onChange={(e) => guardarEstadoFormulario(e)} />
                                <br></br>

                                <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_observaciones")}</span>
                            </Col>



                            <Col md={24}>
                                <span>{traducirPagina("Tipo_cliente")} </span>

                                <div className='separador_input container_nuevo_tipo'>
                                    {
                                        <select disabled={tipoCliente === null ? true : false} value={payLoadLocal.ID_TIPO_CLIENTE} className="custom-select"
                                            onChange={(e) => {
                                                payLoadLocal.ID_TIPO_CLIENTE = parseInt(e.target.value)
                                                setPayLoadLocal({ ...payLoadLocal })
                                            }}

                                        >
                                            <option key={0} value={0}>{traducirPagina("Msg_Tipo_cliente")}</option>

                                            {
                                                tipoCliente !== null &&
                                                    tipoCliente.length > 0 ?
                                                    tipoCliente.map((pais) =>
                                                        <option key={pais.ID} value={pais.ID}>{pais.DESCRIPCION}</option>
                                                    )
                                                    :
                                                    null
                                            }
                                        </select>

                                    }

                                    <button className='btn_new_cliente btnColores' onClick={(e) => { setABRIR_FICHA_TIPO_CLIENTE(true) }}><UserAddOutlined></UserAddOutlined> {traducirPagina("btn_tipo_cliente")} </button>
                                </div>

                                <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_tipo_cliente")}</span>
                            </Col>



                            {ID_ROL === 2 &&
                                <>
                                    <Col md={24}>
                                        <span>{traducirPagina("disenio_especial")} </span>
                                    </Col>
                                    <Col md={24}>
                                        <Input name="PLANTILLA" value={payLoadLocal.PLANTILLA} onChange={(e) => guardarEstadoFormulario(e)} />

                                        <br></br>

                                        <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_disenno_especial")}</span>

                                    </Col>
                                </>
                            }

                        </Row>

                    </TabPane>


                    <TabPane tab={traducirPagina("titulo_conexion_erp")} key="2" className="altura_container_licencias">
                        <Alert message={traducirPagina("subTitulo_conexion_erp")} type="info" className="personalizar_alert" />

                        <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000', overflow: 'auto' }}>

                            <div style={{ margin: '40px 0px 40px 15px' }}>
                                <Checkbox name="SOLO_CATALOGO" checked={payLoadLocal.SOLO_CATALOGO} onChange={(e) => { guardarEstadoFormulario(e) }}>  <span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Catalogo_erp")} </span> </Checkbox>
                                <br></br>
                                <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("subtitulo_catalogo_sin_conexion")}</span>
                            </div>




                            <div className='container_conexion_erp'>

                                {payLoadLocal.NOMBRE_TIENDA_RETAIL !== undefined && payLoadLocal.NOMBRE_TIENDA_RETAIL !== null && payLoadLocal.NOMBRE_TIENDA_RETAIL !== "" &&

                                    <div style={{ marginBottom: '10px' }}>

                                        <span className='span_title' style={{ display: 'block' }}>{traducirPagina("Nombre_tienda")} </span>

                                        <Input disabled={true} name="NOMBRE_TIENDA_RETAIL" value={payLoadLocal.NOMBRE_TIENDA_RETAIL} />

                                    </div>

                                }


                                <div className='item_conexion_erp'>
                                    <div>
                                        <span className='span_title'>{traducirPagina("Cliente_ERP")} </span>
                                        <Input className='separador_input' disabled={true} name="CLIENTE" value={payLoadLocal.CLIENTE} onChange={(e) => guardarEstadoFormulario(e)} />
                                        <br></br>
                                        <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_cliente_erp")}</span>
                                    </div>

                                    <div>
                                        <span className='span_title'>{traducirPagina("Centro_cliente_ERP")} </span>
                                        <Input className='separador_input' disabled={payLoadLocal.SOLO_CATALOGO} name="CENTRO" value={payLoadLocal.CENTRO} onChange={(e) => guardarEstadoFormulario(e)} />
                                        <br></br>
                                        <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_centro")}</span>
                                    </div>
                                </div>


                                <div className='item_conexion_erp tam_emprasa'>
                                    <div>
                                        <span className='span_title'>{traducirPagina("Empresa_ERP")} </span>
                                        <Input className='separador_input' disabled={payLoadLocal.SOLO_CATALOGO} name="EMPRESA_SOCIO" value={payLoadLocal.EMPRESA_SOCIO} onChange={(e) => guardarEstadoFormulario(e)} />
                                        <br></br>

                                        <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("Info_cliente_empresa")}</span>
                                    </div>

                                    <div>
                                        <span className='span_title'>{traducirPagina("Almacen_ERP")} </span>
                                        <Input className='separador_input' disabled={payLoadLocal.SOLO_CATALOGO} name="ALMACEN" value={payLoadLocal.ALMACEN} onChange={(e) => guardarEstadoFormulario(e)} />
                                        <br></br>
                                        <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_almacen_erp")}</span>
                                    </div>
                                </div>

                                <div style={{ marginBottom: '10px' }}>
                                    <Checkbox disabled={payLoadLocal.SOLO_CATALOGO} name="FILTRAR_MARCAS" checked={payLoadLocal.FILTRAR_MARCAS} onChange={(e) => { guardarEstadoFormulario(e) }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Filtrar_ERP")}</span> </Checkbox>
                                    <br></br>
                                    <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("Info_filtrar_ERP")}</span>
                                </div>

                                <div style={{ marginBottom: '10px' }}>
                                    <Checkbox disabled={payLoadLocal.SOLO_CATALOGO} name="VER_SOLO_REFERENCIAS_MARCAS_SOCIO" checked={payLoadLocal.VER_SOLO_REFERENCIAS_MARCAS_SOCIO} onChange={(e) => { guardarEstadoFormulario(e) }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Visualizacion_ERP")}</span> </Checkbox>
                                    <br></br>
                                    <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("Info_Visualizacion_ERP")}</span>
                                </div>

                                <div style={{ marginBottom: '10px' }}>
                                    <Checkbox name="VISUALIZAR_ADICIONALES" checked={payLoadLocal.VISUALIZAR_ADICIONALES} onChange={(e) => { guardarEstadoFormulario(e) }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Visualizacion_adicional")}</span> </Checkbox>
                                    <br></br>
                                    <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("conexionerp_item_adicionales")}</span>
                                </div>

                            </div>
                        </Row>
                    </TabPane>

                    <TabPane tab={traducirPagina("titulo_catalogo")} key="3" className="altura_container_licencias">

                        <Alert message={traducirPagina("info_doc_catalogosexternos")} type="info" className="personalizar_alert" />

                        <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000', overflow: 'auto' }} >

                            <div className='container_conexion_erp' style={{ margin: '20px 0px 0px 0px', border: 'none', paddingBottom: '0px', paddingTop: '0px' }}>
                                <div className="espaciador_div">
                                    <Checkbox name="PERMISO_MOTOS" checked={payLoadLocal.PERMISO_MOTOS} onChange={(e) => { guardarEstadoFormulario(e) }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Permiso_motos")}</span> </Checkbox>
                                    <br></br>

                                    <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_catalogomoto")}</span>
                                </div>


                                <div className="espaciador_div">

                                    <Checkbox name="PERMISO_NEUMATICOS" checked={payLoadLocal.PERMISO_NEUMATICOS} onChange={(e) => { guardarEstadoFormulario(e) }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Permiso_neumaticos")}</span> </Checkbox>
                                    <br></br>

                                    <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_catalogoneumatico")}</span>

                                </div>

                                <div className="espaciador_div">
                                    <Checkbox name="PERMISO_BATERIAS" checked={payLoadLocal.PERMISO_BATERIAS} onChange={(e) => { guardarEstadoFormulario(e) }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Permiso_baterias")}</span> </Checkbox>
                                    <br></br>

                                    <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_catalogobaterias")}</span>

                                </div>

                                <div >
                                    <Checkbox name="PERMISO_LUBRICANTES" checked={payLoadLocal.PERMISO_LUBRICANTES} onChange={(e) => { guardarEstadoFormulario(e) }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Permiso_lubricantes")}</span> </Checkbox>
                                    <br></br>

                                    <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_catalogolubricantes")}</span>
                                </div>
                            </div>


                            <div className='container_conexion_erp' style={{ margin: '20px 0px' }}>
                                <div>
                                    <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_matriculas")}</span>
                                </div>

                                <div className='item_conexion_erp'>
                                    <div>
                                        <div style={{ marginBottom: '10px' }}>

                                            <Checkbox name="PERMISO_MATRICULAS" checked={payLoadLocal.PERMISO_MATRICULAS} onChange={(e) => { guardarEstadoFormulario(e) }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Permiso_matriculas")}</span> </Checkbox>
                                        </div>


                                        <Input name="MAXIMO_MATRICULAS_MENSUAL" value={payLoadLocal.MAXIMO_MATRICULAS_MENSUAL} onChange={(e) => guardarEstadoFormulario(e)} disabled={!payLoadLocal.PERMISO_MATRICULAS} />

                                        <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("Maximo_matriculas")}</span>
                                    </div>

                                    <div>
                                        <div style={{ marginBottom: '10px' }}>

                                            <Checkbox name="PERMISO_BASTIDORES" checked={payLoadLocal.PERMISO_BASTIDORES} onChange={(e) => { guardarEstadoFormulario(e) }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Permiso_bastidores")}</span> </Checkbox>
                                        </div>

                                        <Input name="MAXIMO_BASTIDORES_MENSUAL" value={payLoadLocal.MAXIMO_BASTIDORES_MENSUAL} onChange={(e) => guardarEstadoFormulario(e)} disabled={!payLoadLocal.PERMISO_BASTIDORES} />
                                        <br></br>

                                        <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("Maximo_bastidores")}</span>
                                    </div>
                                </div>
                            </div>


                            <div className='container_conexion_erp' style={{ margin: '0px', border: 'none', paddingBottom: '0px' }}>

                                <div className='item_conexion_erp  className="espaciador_div"' >
                                    <div>
                                        <div style={{ marginBottom: '10px' }}>

                                            <Checkbox name="PERMISO_PRESUPUESTOS_GTESTIMATE" checked={payLoadLocal.PERMISO_PRESUPUESTOS_GTESTIMATE} onChange={(e) => { guardarEstadoFormulario(e) }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Presupuesto_GT")}</span> </Checkbox>
                                            <br></br>

                                            <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_gtestimate")}</span>

                                        </div>

                                        <Input name="MAXIMO_PRESUPUESTOS_GTESTIMATE" value={payLoadLocal.MAXIMO_PRESUPUESTOS_GTESTIMATE} onChange={(e) => guardarEstadoFormulario(e)} disabled={!payLoadLocal.PERMISO_PRESUPUESTOS_GTESTIMATE} />
                                        <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("Maximo_presupuesto")}</span>
                                    </div>


                                    <div>
                                        <div style={{ marginBottom: '10px' }}>
                                            <Checkbox name="PERMISO_CATALOGO_ORIGINAL" checked={payLoadLocal.PERMISO_CATALOGO_ORIGINAL} onChange={(e) => { guardarEstadoFormulario(e) }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Permiso_original")}</span> </Checkbox>
                                            <br></br>

                                            <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("titulo_catoem")}</span>

                                        </div>

                                        <Input name="MAXIMO_CATALOGO_ORIGINAL" value={payLoadLocal.MAXIMO_CATALOGO_ORIGINAL} onChange={(e) => guardarEstadoFormulario(e)} disabled={!payLoadLocal.PERMISO_CATALOGO_ORIGINAL} />
                                        <br></br>
                                        <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("Numero_max_original")}</span>
                                    </div>
                                </div>

                            </div>
                        </Row>
                    </TabPane>


                    <TabPane tab={traducirPagina("Configuracion")} key="4" className="altura_container_licencias">

                        <Alert message={traducirPagina("configuracion_info_doc")} type="info" className="personalizar_alert" />

                        <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000', overflow: 'auto' }}>

                            <div style={{ padding: '0px 20px' }}>


                                <div style={{ marginTop: '10px', marginBottom: '20px' }}>
                                    <Checkbox name="MOSTRAR_BOTON_POR_DEFECTO" checked={payLoadLocal.MOSTRAR_BOTON_POR_DEFECTO} onChange={(e) => { guardarEstadoFormulario(e) }}>  <span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Boton_por_defecto")} </span> </Checkbox>
                                    <br></br>
                                    <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("Info_boton_fecto")}</span>
                                </div>


                                <div style={{ marginTop: '10px' }}>
                                    <Checkbox name="ABRIR_SIEMPRE_DESGLOSE_COMPRAR" checked={payLoadLocal.ABRIR_SIEMPRE_DESGLOSE_COMPRAR} onChange={(e) => { guardarEstadoFormulario(e) }}>  <span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Abrir_desglose")} </span> </Checkbox>
                                    <br></br>
                                    <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("Info_abrir_desglose")}</span>
                                </div>

                                <div style={{ marginTop: '10px' }}>
                                    <Checkbox name="CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA" checked={payLoadLocal.CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA} onChange={(e) => { guardarEstadoFormulario(e) }}>  <span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Abrir_Naranja")} </span> </Checkbox>
                                    <br></br>
                                    <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("Info_abrir_Naranja")}</span>
                                </div>

                                <div style={{ marginTop: '10px', marginBottom: '30px' }}>
                                    <Checkbox name="COMPRAR_SIN_DISPONIBILIDAD" checked={payLoadLocal.COMPRAR_SIN_DISPONIBILIDAD} onChange={(e) => { guardarEstadoFormulario(e) }}>  <span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Compra_negativa")} </span> </Checkbox>
                                    <br></br>
                                    <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("Info_compra_negativa")}</span>
                                </div>
                            </div>

                            {
                                /*
                                    <Col md={24} style={{ marginTop: '10px' }}>
                                                            <Checkbox name="DEFECTO" checked={payLoadLocal.DEFECTO} onChange={(e) => { guardarEstadoFormulario(e) }}>  <span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Licencia_defecto")} </span> </Checkbox>
                                                        </Col>
                            
                                 */
                            }




                            <div className='container_conexion_erp' style={{ margin: '20px 0px' }}>
                                <div>
                                    <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("configuracion_info_disponibilidad")}</span>
                                </div>

                                <div className='item_conexion_erp'>
                                    <div>
                                        <Checkbox name="SEMAFORO_DISPONIBILIDAD" checked={payLoadLocal.SEMAFORO_DISPONIBILIDAD} onChange={(e) => { guardarEstadoFormulario(e) }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Disp_semaforo_verde")}</span> </Checkbox>
                                        <br></br>
                                        <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("configuracion_titulo_semaforo")}</span>
                                    </div>

                                    <div>
                                        <Checkbox name="SIEMPRE_VERDE" checked={payLoadLocal.SIEMPRE_VERDE} onChange={(e) => { guardarEstadoFormulario(e) }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Semaforo_verde")}</span> </Checkbox>
                                        <br></br>

                                        <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("configuracion_titulo_siempreverde")}</span>
                                    </div>
                                </div>
                            </div>


                            <div style={{ margin: '10px 0px', padding: '0px 20px' }}>
                                <Checkbox name="VISUALIZAR_PVP" checked={payLoadLocal.VISUALIZAR_PVP} onChange={(e) => { guardarEstadoFormulario(e) }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Visualizacion_pvp")}</span> </Checkbox>
                                <br></br>

                                <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("configuracion_titulo_visualpvp")}</span>
                            </div>

                            <div style={{ margin: '10px 0px', padding: '0px 20px' }}>
                                <Checkbox className='texto_data_descripcion' checked={payLoadLocal.PERMISO_DOCUMENTACION_TECNICA} name="PERMISO_DOCUMENTACION_TECNICA" onChange={(e) => { guardarEstadoFormulario(e) }} ><span style={{ fontSize: '16px', fontWeight: '500' }}>{traducirPagina("nextadata_item_textvisibilidad")}</span> </Checkbox>
                                <br></br>
                                <div style={{ fontSize: '14px', fontWeight: 'normal', color: '#999', textAlign: 'justify', marginTop: '5px' }}>{traducirPagina("nextadata_subtitulo_textvisibilidad")}</div>
                            </div>


                        </Row>
                    </TabPane>

                    <TabPane tab={"NextData"} key="5" className="altura_container_licencias">

                        <Alert message={traducirPagina("info_next_data")} type="info" className="personalizar_alert" />


                        <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000', overflow: 'auto' }}>

                            <div className='form_next_data'>
                                <div className='grupo_item_data1'>

                                    <div className='grupo_data_titulo' style={{ justifyContent: 'space-between' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                            {traducirPagina("nextdata_item_basic")}

                                            <Popover
                                                content={<div className='grupo_data_subtitulotitulo'>{traducirPagina("nextdata_subtitulo_basic")}</div>}
                                                title={traducirPagina("nextdata_item_basic")}
                                                trigger="hover"> <InfoCircleOutlined></InfoCircleOutlined>
                                            </Popover>
                                        </div>

                                        {/*
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button className='btnShopData' style={{ backgroundColor: !payLoadLocal.DAR_BAJA_BASIC ? '#FF6961' : '#4285f4', color: '#fff' }} onClick={() => {
                        if (!payLoadLocal.DAR_BAJA_BASIC) {
                            setBajaBasic(true)
                        } else {
                            payLoadLocal.DAR_BAJA_BASIC = !payLoadLocal.DAR_BAJA_BASIC;
                            setPayLoadLocal({ ...payLoadLocal })
                        }

                    }}>{payLoadLocal.DAR_BAJA_BASIC ? <> <ShoppingOutlined> </ShoppingOutlined> {"Incluir"}</> : <> <DeleteOutlined></DeleteOutlined> {"No incluir"}</>}  </button>
                </div>
*/}
                                    </div>

                                    <div className='agrupar_data'>
                                        <small className='titulo_agrupar_data'>{traducirPagina("nextdata_item_origen")}</small>
                                        <div>
                                            <div className='ct_basic_grupo'>


                                                <div style={payLoadData.ESTADO_BASIC === 1 ? { width: '100%' } : {}}>

                                                    <Select
                                                        showSearch
                                                        value={payLoadLocal.ORIGEN_NEXTDATA_BASIC}
                                                        disabled={payLoadLocal.CAMBIAR_ORIGEN_NEXT_DATA_BASIC ? false : (payLoadData.ESTADO_BASIC === 2 || payLoadData.ESTADO_BASIC === 0)}
                                                        optionFilterProp="children"
                                                        style={{ width: '100%' }}
                                                        onChange={(e) => {


                                                            payLoadLocal.ORIGEN_NEXTDATA_BASIC = e
                                                            setPayLoadLocal({ ...payLoadLocal })
                                                        }}
                                                        filterOption={(input, option) =>
                                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                    >
                                                        {servicios.map((item) =>
                                                            <Option key={item.CODIGO} value={item.CODIGO}>{item.NOMBRE}</Option>
                                                        )}

                                                    </Select>
                                                </div>

                                                {
                                                    payLoadData.ESTADO_BASIC === 2 || payLoadData.ESTADO_BASIC === 0 ?

                                                        !payLoadLocal.CAMBIAR_ORIGEN_NEXT_DATA_BASIC &&
                                                        <div className='btn_actualizar_basic' onClick={() => {
                                                            payLoadLocal.CAMBIAR_ORIGEN_NEXT_DATA_BASIC = true;

                                                            setPayLoadLocal({ ...payLoadLocal })
                                                        }}>
                                                            <button><ReloadOutlined></ReloadOutlined> </button>

                                                        </div>
                                                        :
                                                        null
                                                }

                                            </div>
                                        </div>
                                    </div>

                                    <div className='agrupar_data' style={{ display: 'flex', justifyContent: 'center', height: '157px', opacity: '0.2' }}>
                                        <img src="./imagenes/herramienta.png"></img>

                                    </div>


                                    <div className='agrupar_data '>
                                        <small className='titulo_agrupar_data'>{traducirPagina("nextdata_item_fecha_alta")}</small>

                                        <div className='texto_data_descripcion agrupar_historial'>
                                            {payLoadLocal.FECHA_NEXTDATA_BASIC === "" ? traducirPagina("nextdata_item_fecha_alta_sd") : payLoadLocal.FECHA_NEXTDATA_BASIC}

                                            <div style={{ display: 'flex', gap: '10px' }} className={`grupoBtnData ${payLoadData.ESTADO_BASIC === 0 ? "btnProcessCompra" : (payLoadData.ESTADO_BASIC === 2) && "btnBajaCompra"}`}>

                                                <button className='btnShopData' title={traducirPagina("nextdata_item_historial")} onClick={() => {
                                                    if (props.ID_USUARIO !== 0) {
                                                        HistorialUsuario(props.ID_USUARIO)
                                                    }

                                                    fichaHistorial.ABRIR_FICHA = true
                                                    fichaHistorial.ID_VERSION = 5
                                                    fichaHistorial.TIPO_ORIGEN = "NEXT_DATA"
                                                    setFichaHistorial({ ...fichaHistorial })


                                                }}><FieldTimeOutlined></FieldTimeOutlined></button>


                                                {modificarBasic &&
                                                    <button className='btnShopData btn_accion_data btnColores' style={{ minWidth: '120px' }}
                                                        onClick={() => {
                                                            if (payLoadData.ESTADO_BASIC === 1) {
                                                                confirmarCompra.ABRIR_MODAL = true
                                                                confirmarCompra.ID_COMPRA_SELECCIONADA = 1
                                                                setConfirmarCompra({ ...confirmarCompra })
                                                            } else {
                                                                payLoadLocal.CREAR_NEXT_DATA_BASIC = false
                                                                payLoadLocal.BAJA_NEXT_DATA_BASIC = true
                                                                setPayLoadLocal({ ...payLoadLocal })

                                                                payLoadData.ESTADO_BASIC = 0
                                                                setPayLoadData({ ...payLoadData })
                                                            }
                                                        }}
                                                    >

                                                        {
                                                            payLoadData.ESTADO_BASIC === 0 ?
                                                                <>  <LoadingOutlined></LoadingOutlined> {traducirPagina("txt_procesando")}</>
                                                                :
                                                                payLoadData.ESTADO_BASIC === 1 ?
                                                                    <>   <ShoppingOutlined></ShoppingOutlined> {traducirPagina("nextdata_btn_comprar")} </>
                                                                    :
                                                                    <>   <DeleteOutlined></DeleteOutlined> {traducirPagina("txt_dar_baja")} </>
                                                        }
                                                    </button>
                                                }


                                            </div>

                                        </div>
                                    </div>
                                </div>



                                <div className='grupo_item_data2'>
                                    <div className='grupo_data_titulo'>{traducirPagina("nextada_item_manuales_reparacion")}
                                        <Popover
                                            content={<div className='grupo_data_subtitulotitulo'>{traducirPagina("nextada_manuales_reparacion")}</div>}
                                            title={traducirPagina("nextada_item_manuales_reparacion")}
                                            trigger="hover"> <InfoCircleOutlined></InfoCircleOutlined>
                                        </Popover>
                                    </div>


                                    <div className='agrupar_data'>
                                        <small className='titulo_agrupar_data'>{traducirPagina("nextdata_item_origen")}</small>
                                        <div>
                                            <div style={{ margin: '5px 0px 10px 0px' }}>
                                                <Select
                                                    showSearch
                                                    value={payLoadLocal.ORIGEN_NEXTDATA_MANUALES}
                                                    disabled={payLoadData.ESTADO_REPARACION === 2 || payLoadData.ESTADO_REPARACION === 0}
                                                    optionFilterProp="children"
                                                    style={{ width: '100%' }}
                                                    onChange={(e) => {
                                                        payLoadLocal.ORIGEN_NEXTDATA_MANUALES = e
                                                        setPayLoadLocal({ ...payLoadLocal })
                                                    }}
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {servicios.map((item) =>
                                                        <Option key={item.CODIGO} value={item.CODIGO}>{item.NOMBRE}</Option>
                                                    )}

                                                </Select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='agrupar_data' style={{ display: 'flex', justifyContent: 'center', height: '157px', opacity: '0.2' }}>
                                        <img src="./imagenes/herramienta.png"></img>
                                    </div>

                                    <div className='agrupar_data '>
                                        <small className='titulo_agrupar_data'>{traducirPagina("nextdata_item_fecha_alta")}</small>


                                        <div className='texto_data_descripcion agrupar_historial'>
                                            {payLoadLocal.FECHA_NEXTDATA_MANUALES === "" ? traducirPagina("nextdata_item_fecha_alta_sd") : payLoadLocal.FECHA_NEXTDATA_MANUALES}

                                            <div style={{ display: 'flex', gap: '10px' }} className={`grupoBtnData ${payLoadData.ESTADO_REPARACION === 0 ? "btnProcessCompra" : payLoadData.ESTADO_REPARACION === 2 && "btnBajaCompra"}`}>
                                                <button className='btnShopData' title={traducirPagina("nextdata_item_historial")} onClick={() => {
                                                    if (props.ID_USUARIO !== 0) {
                                                        HistorialUsuario(props.ID_USUARIO)
                                                    }
                                                    fichaHistorial.ABRIR_FICHA = true
                                                    fichaHistorial.ID_VERSION = 4
                                                    fichaHistorial.TIPO_ORIGEN = "NEXT_DATA"
                                                    setFichaHistorial({ ...fichaHistorial })
                                                }}><FieldTimeOutlined></FieldTimeOutlined></button>

                                                <button className='btnShopData btn_accion_data btnColores' style={{ minWidth: '120px' }} onClick={() => {


                                                    if (payLoadData.ESTADO_REPARACION === 1) {
                                                        confirmarCompra.ABRIR_MODAL = true
                                                        confirmarCompra.ID_COMPRA_SELECCIONADA = 2
                                                        setConfirmarCompra({ ...confirmarCompra })
                                                    } else {
                                                        payLoadLocal.CREAR_NEXT_DATA_MANUALES = false
                                                        payLoadLocal.BAJA_NEXT_DATA_MANUALES = true
                                                        setPayLoadLocal({ ...payLoadLocal })

                                                        payLoadData.ESTADO_REPARACION = 0
                                                        setPayLoadData({ ...payLoadData })
                                                    }

                                                }}>

                                                    {
                                                        payLoadData.ESTADO_REPARACION === 0 ?
                                                            <>  <LoadingOutlined></LoadingOutlined> {traducirPagina("txt_procesando")}</>
                                                            :
                                                            payLoadData.ESTADO_REPARACION === 1 ?
                                                                <>   <ShoppingOutlined></ShoppingOutlined> {traducirPagina("nextdata_btn_comprar")} </>
                                                                :
                                                                <>   <DeleteOutlined></DeleteOutlined> {traducirPagina("txt_dar_baja")} </>
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>





                                <div className='grupo_item_data3'>
                                    <div className='grupo_data_titulo'>
                                        {traducirPagina("nextdata_item_completo")}
                                        <Popover
                                            content={<div className='grupo_data_subtitulotitulo'>{traducirPagina("nextdata_subtitulo_completo")}</div>}
                                            title={traducirPagina("nextdata_item_completo")}
                                            trigger="hover"> <InfoCircleOutlined></InfoCircleOutlined>
                                        </Popover>
                                    </div>


                                    <div className='agrupar_data'>
                                        <small className='titulo_agrupar_data'>{traducirPagina("nextdata_item_origen")}</small>
                                        <div>
                                            <div style={{ margin: '5px 0px 10px 0px' }}>
                                                <Select
                                                    showSearch
                                                    value={payLoadLocal.ORIGEN_NEXTDATA_COMPLETO}
                                                    disabled={payLoadData.ESTADO_COMPLETO === 2 || payLoadData.ESTADO_COMPLETO === 0}
                                                    allowClear={true}
                                                    optionFilterProp="children"
                                                    style={{ width: '100%' }}
                                                    onChange={(e) => {
                                                        payLoadLocal.ORIGEN_NEXTDATA_COMPLETO = e
                                                        setPayLoadLocal({ ...payLoadLocal })
                                                    }}
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {servicios.map((item) =>
                                                        <Option key={item.CODIGO} value={item.CODIGO}>{item.NOMBRE}</Option>
                                                    )}

                                                </Select>
                                            </div>

                                        </div>
                                    </div>


                                    <div className='agrupar_data'>
                                        <small className='titulo_agrupar_data'>{traducirPagina("Credenciales")}</small>
                                        <div>

                                            <div style={{ margin: '5px 0px 10px 0px' }}>
                                                <small>{traducirPagina("Usuario")} </small>
                                                <Input disabled={payLoadData.ESTADO_COMPLETO === 2 || payLoadData.ESTADO_COMPLETO === 0} name="USUARIO_NEXTDATA_COMPLETO" autocomplete="off" value={payLoadLocal.USUARIO_NEXTDATA_COMPLETO} onChange={(e) => guardarEstadoFormulario(e)} />

                                            </div>
                                            <div style={{ margin: '5px 0px 10px 0px' }}>
                                                <small>{traducirPagina("Contrasenia")} </small>
                                                <Input disabled={payLoadData.ESTADO_COMPLETO === 2 || payLoadData.ESTADO_COMPLETO === 0} name="PWD_NEXTDATA_COMPLETO" autocomplete="off" value={payLoadLocal.PWD_NEXTDATA_COMPLETO} onChange={(e) => guardarEstadoFormulario(e)} />
                                            </div>
                                        </div>
                                    </div>



                                    <div className='agrupar_data '>
                                        <small className='titulo_agrupar_data'>{traducirPagina("nextdata_item_fecha_alta")}</small>
                                        <div className='texto_data_descripcion agrupar_historial'>
                                            {payLoadLocal.FECHA_NEXTDATA_COMPLETO === "" ? traducirPagina("nextdata_item_fecha_alta_sd") : payLoadLocal.FECHA_NEXTDATA_COMPLETO}

                                            <div style={{ display: 'flex', gap: '10px' }} className={`grupoBtnData ${payLoadData.ESTADO_COMPLETO === 0 ? "btnProcessCompra" : payLoadData.ESTADO_COMPLETO === 2 && "btnBajaCompra"}`}>

                                                <button className='btnShopData' title={traducirPagina("nextdata_item_historial")} onClick={() => {
                                                    if (props.ID_USUARIO !== 0) {
                                                        HistorialUsuario(props.ID_USUARIO)
                                                    }
                                                    fichaHistorial.ABRIR_FICHA = true
                                                    fichaHistorial.ID_VERSION = 1
                                                    fichaHistorial.TIPO_ORIGEN = "NEXT_DATA"
                                                    setFichaHistorial({ ...fichaHistorial })
                                                }}><FieldTimeOutlined></FieldTimeOutlined> </button>

                                                <button disabled={payLoadLocal.CREAR_NEXT_DATA_COMPLETO} className='btnShopData btn_accion_data btnColores' style={{ minWidth: '120px' }}
                                                    onClick={() => {

                                                        if (payLoadData.ESTADO_COMPLETO === 1) {
                                                            if (payLoadLocal.USUARIO_NEXTDATA_COMPLETO === "" && payLoadLocal.PWD_NEXTDATA_COMPLETO === "") {
                                                                MSGERROR("Ingrese un usuario y contraseña")
                                                            } else {
                                                                confirmarCompra.ABRIR_MODAL = true
                                                                confirmarCompra.ID_COMPRA_SELECCIONADA = 3
                                                                setConfirmarCompra({ ...confirmarCompra })

                                                            }

                                                        } else {
                                                            payLoadLocal.CREAR_NEXT_DATA_COMPLETO = false
                                                            payLoadLocal.BAJA_NEXT_DATA_COMPLETO = true
                                                            setPayLoadLocal({ ...payLoadLocal })

                                                            payLoadData.ESTADO_COMPLETO = 0
                                                            setPayLoadData({ ...payLoadData })
                                                        }

                                                    }}
                                                >

                                                    {
                                                        payLoadData.ESTADO_COMPLETO === 0 ?
                                                            <>  <LoadingOutlined></LoadingOutlined> {traducirPagina("txt_procesando")}</>
                                                            :
                                                            payLoadData.ESTADO_COMPLETO === 1 ?
                                                                <>   <ShoppingOutlined></ShoppingOutlined> {traducirPagina("nextdata_btn_comprar")} </>
                                                                :
                                                                <>   <DeleteOutlined></DeleteOutlined> {traducirPagina("txt_dar_baja")} </>
                                                    }
                                                </button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </Row>
                    </TabPane>

                    <TabPane tab={"NextControl Lite"} key="6" className="altura_container_licencias">
                        <Alert message={<div>{traducirPagina("titulo_next_control")}


                        </div>} type="info" className="personalizar_alert" />

                        <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000', overflow: 'auto' }} >



                            <div className='form_next_data'>

                                <div className='grupo_item_data1' style={{ /*alignSeft: 'center', justifySelf: 'center',*/ width: '400px' }}>
                                    <div className='grupo_data_titulo'>{"NextControl Lite"}
                                        <Popover
                                            content={<><div>{traducirPagina("subtitulo_next_control")}</div> <ul>{traducirPagina("info_item_next_control").split("-").map((item) => <li style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{item}</li>)} </ul></>}
                                            title={"NextControl Lite"}
                                            trigger="hover"> <InfoCircleOutlined></InfoCircleOutlined>
                                        </Popover>
                                    </div>



                                    <div className='agrupar_data' style={{ display: 'flex', justifyContent: 'center', opacity: '0.2', margin: '20px 0px' }}>
                                        <EuroCircleOutlined style={{ fontSize: '200px' }}></EuroCircleOutlined>

                                    </div>


                                    <div className='agrupar_data '>
                                        <small className='titulo_agrupar_data'>{traducirPagina("nextdata_item_fecha_alta")}</small>


                                        <div className='texto_data_descripcion agrupar_historial'>
                                            {payLoadLocal.FECHA_CONTROL_LITE === "" ? traducirPagina("nextdata_item_fecha_alta_sd") : payLoadLocal.FECHA_CONTROL_LITE}

                                            <div style={{ display: 'flex', gap: '10px' }} className={`grupoBtnData ${payLoadData.ESTADO_CONTROL_LITE === 0 ? "btnProcessCompra" : payLoadData.ESTADO_CONTROL_LITE === 2 && "btnBajaCompra"}`}>
                                                <button className='btnShopData' title={traducirPagina("nextdata_item_historial")} onClick={() => {
                                                    if (props.ID_USUARIO !== 0) {
                                                        HistorialUsuarioLite(props.ID_USUARIO)
                                                    }
                                                    fichaHistorial.ABRIR_FICHA = true
                                                    fichaHistorial.ID_VERSION = 0
                                                    fichaHistorial.TIPO_ORIGEN = "CONTROL_LITE"


                                                    setFichaHistorial({ ...fichaHistorial })
                                                }}><FieldTimeOutlined></FieldTimeOutlined></button>

                                                <button className='btnShopData btn_accion_data btnColores' style={{ minWidth: '120px' }}
                                                    onClick={() => {
                                                        if (payLoadData.ESTADO_CONTROL_LITE === 1) {
                                                            confirmarCompra.ABRIR_MODAL = true
                                                            confirmarCompra.ID_COMPRA_SELECCIONADA = 0
                                                            setConfirmarCompra({ ...confirmarCompra })
                                                        } else {
                                                            payLoadData.ESTADO_CONTROL_LITE = 0

                                                            payLoadLocal.FACTURACION_LITE = false
                                                            setPayLoadLocal({ ...payLoadLocal })
                                                            setPayLoadData({ ...payLoadData })
                                                        }


                                                    }}
                                                >


                                                    {
                                                        payLoadData.ESTADO_CONTROL_LITE === 0 ?
                                                            <>  <LoadingOutlined></LoadingOutlined> {traducirPagina("txt_procesando")}</>
                                                            :
                                                            payLoadData.ESTADO_CONTROL_LITE === 1 ?
                                                                <>   <ShoppingOutlined></ShoppingOutlined> {traducirPagina("nextdata_btn_comprar")} </>
                                                                :
                                                                <>   <DeleteOutlined></DeleteOutlined> {traducirPagina("txt_dar_baja")} </>
                                                    }

                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>




                            {/*
    <Col md={24} style={{ marginTop: '10px' }}>
        <Checkbox name="FACTURACION_LITE" checked={payLoadLocal.FACTURACION_LITE} onChange={(e) => { guardarEstadoFormulario(e) }}>  <span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Info_facturacion_lite")} </span> </Checkbox>
        <br />

        <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("subtitulo_next_control")}</span>
    </Col>
     */}
                        </Row>
                    </TabPane>
                </Tabs>


                <div className="container_guardar_cliente">
                    <button className="btnShopData btnColores" onClick={(e) => { crearUsuario() }}><SaveOutlined style={{ fontSize: '20px' }} /> <span>{traducirPagina("Guardar_salir").toUpperCase()} </span>  </button>
                </div>


            </Drawer>

            {
                ABRIR_FICHA_TIPO_CLIENTE ?
                    <MantenimientoTipoCLiente
                        title={traducirPagina("Tipo_cliente").toUpperCase()}
                        ABRIR_FICHA={ABRIR_FICHA_TIPO_CLIENTE}
                        CERRAR_FICHA={setABRIR_FICHA_TIPO_CLIENTE}
                        ACTUALIZAR_TABLA={actualizarEstado}
                        SOCIO_SELECCIONADO={props.ID_SOCIO}
                        TIPO={""}

                    >

                    </MantenimientoTipoCLiente>
                    :

                    null
            }


            <Modal
                visible={visible}
                width={700}
                centered
                zIndex={1000}
                title={traducirPagina("titulo_modal_doc_tecnica").toUpperCase()}
                afterClose={() => { }}
                onCancel={() => setVisible(false)}
                footer={[
                    <Button key="back" onClick={() => { setVisible(false) }}>
                        {traducirPagina("Cancelar").toUpperCase()}

                    </Button>,
                    <Button style={{ backgroundColor: '#000' }} key="submit" type="primary" onClick={() => {
                        payLoadLocal.PERMISO_DOCUMENTACION_TECNICA = !payLoadLocal.PERMISO_DOCUMENTACION_TECNICA;
                        setPayLoadLocal({ ...payLoadLocal })
                        setVisible(false)
                    }}>
                        {traducirPagina("SI").toUpperCase()}

                    </Button>
                ]}
            >
                <Row>
                    <Col md={24} className="mt-2 mb-2">
                        <span className="tituloDoc_tecnica1">{traducirPagina("subtitulo_modal_doc_tecnica_1")} </span>
                        <br />
                        <span className="tituloRecuperarEmail">{traducirPagina("subtitulo_modal_doc_tecnica_2")} </span>
                        <br />
                        {<ul>
                            {traducirPagina("subtitulo_modal_tecnica_apartados").split(" - ").map((registro) =>
                                <>
                                    <li className="tituloRecuperarEmail">{registro} </li>

                                </>
                            )}
                        </ul>
                        }
                    </Col>
                </Row>
            </Modal>



            <Modal
                visible={bajaBasic}
                width={700}
                centered
                zIndex={1000}
                title={traducirPagina("Info_modal").toUpperCase()}
                afterClose={() => { }}
                onCancel={() => setBajaBasic(false)}
                footer={[
                    <Button key="back" onClick={() => { setBajaBasic(false) }}>
                        {traducirPagina("Cancelar").toUpperCase()}

                    </Button>,
                    <Button style={{ backgroundColor: '#000' }} key="submit" type="primary" onClick={() => {
                        payLoadLocal.DAR_BAJA_BASIC = !payLoadLocal.DAR_BAJA_BASIC;
                        setPayLoadLocal({ ...payLoadLocal })

                        setBajaBasic(false)
                    }}>
                        {traducirPagina("SI").toUpperCase()}

                    </Button>
                ]}
            >
                <Row>
                    <Col md={24} className="mt-2 mb-2">
                        <span className="tituloDoc_tecnica1">{traducirPagina("nextadata_item_bajabasic")} </span>

                    </Col>
                </Row>
            </Modal>



            <Modal
                visible={confirmarCompra.ABRIR_MODAL}
                width={700}
                centered
                zIndex={1000}
                title={traducirPagina("Info_modal").toUpperCase()}
                afterClose={() => { }}
                onCancel={() => {
                    confirmarCompra.ABRIR_MODAL = false
                    confirmarCompra.ID_COMPRA_SELECCIONADA = null

                    setConfirmarCompra({ ...confirmarCompra })

                }
                }
                footer={[
                    <Button key="back" onClick={() => {
                        confirmarCompra.ABRIR_MODAL = false
                        confirmarCompra.ID_COMPRA_SELECCIONADA = null
                        setConfirmarCompra({ ...confirmarCompra })
                    }}>
                        {traducirPagina("Cancelar").toUpperCase()}

                    </Button>,
                    <Button style={{ backgroundColor: '#000' }} key="submit" type="primary" onClick={() => {
                        switch (confirmarCompra.ID_COMPRA_SELECCIONADA) {
                            case 1:
                                payLoadLocal.CREAR_NEXT_DATA_BASIC = !payLoadLocal.CREAR_NEXT_DATA_BASIC
                                payLoadData.ESTADO_BASIC = 0
                                break;
                            case 2:
                                payLoadLocal.CREAR_NEXT_DATA_MANUALES = !payLoadLocal.CREAR_NEXT_DATA_MANUALES
                                payLoadData.ESTADO_REPARACION = 0

                                break;
                            case 3:
                                payLoadLocal.CREAR_NEXT_DATA_COMPLETO = !payLoadLocal.CREAR_NEXT_DATA_COMPLETO
                                payLoadData.ESTADO_COMPLETO = 0

                                break;
                        }

                        setPayLoadData({ ...payLoadData })
                        setPayLoadLocal({ ...payLoadLocal })
                        confirmarCompra.ABRIR_MODAL = false
                        confirmarCompra.ID_COMPRA_SELECCIONADA = null
                        setConfirmarCompra({ ...confirmarCompra })

                    }}>
                        {traducirPagina("SI").toUpperCase()}

                    </Button>
                ]}
            >
                <Row>
                    <Col md={24} className="mt-2 mb-2">
                        <span className="tituloDoc_confirmar">{traducirPagina("nextdadta_aviso_servicio_sub")}</span>
                        <span className="tituloDoc_tecnica1">{traducirPagina("nextdadta_aviso_servicio")} </span>

                    </Col>
                </Row>
            </Modal>

            {fichaHistorial.ABRIR_FICHA &&
                <HistorialData
                    ESTADO={fichaHistorial}
                    setEstado={setFichaHistorial}
                    LISTA={historialData}
                    title={traducirPagina("nextdata_item_historial").toUpperCase()}

                >

                </HistorialData>
            }


        </>
    )
}


FichaMantenimientoCliente.propTypes = {
    title: PropTypes.string,
    ESTADO_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    DATOS_CLIENTE_SELECCIONADO: PropTypes.func,
    ID_SOCIO: PropTypes.number,
    ID_USUARIO: PropTypes.number,
    DATOS_CLIENTE: PropTypes.object,
    ACTUALIZAR_LICENCIAS: PropTypes.func,

    TEXTO_BUSCADOR: PropTypes.func
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        configApp: state.configApp,
        clienteTallerSeleccionado: state.clienteTallerSeleccionado,
        VehiculoTallerSeleccionado: state.VehiculoTallerSeleccionado,
        datosFacturacion: state.datosFacturacion,
        usuario: state.usuario
    };
}

export default connect(mapStateToProps)(FichaMantenimientoCliente);